import { authEvents } from './authEvents';
import { sessionManager } from './sessionManager';
import { API } from '../apiservice/api';

export const validateSession = async (newToken=null) => {
  if (sessionManager.isSessionValid()) return true;

  // Use the token from session storage if no new token is provided
  const token = newToken || sessionManager.getToken();
  
  if (!token) {
    return false;
  }

  try {
    // Create a custom request that doesn't send cookies
    // This is needed because the validation API doesn't expect any cookies (like JSESSIONID)
    const BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001/api';
    
    // Use fetch with credentials: 'omit' to ensure no cookies are sent
    const response = await fetch(`${BASE_URL}${API.VALIDATE_TOKEN}`, {
      method: 'GET',
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      // credentials: 'omit' ensures no cookies are sent with this request
      credentials: 'omit'
    });
    
    if (!response.ok) {
      throw new Error(`Validation failed with status: ${response.status}`);
    }
    
    sessionManager.markSessionValid();
    authEvents.reset();
    
    const params = new URLSearchParams(window.location.search);
    const userId = params.get("svcManagerId");

    if (userId && !sessionManager.getUserId()) {
      sessionManager.setUserId(userId);
    }
    //TODO: Get role from cookie if available
    
    return true;
  } catch (error) {
    console.error('Token validation failed:', error);
    return false;
  }
};
